module.exports = __webpack_public_path__ + "img/Layer 6.e7118ee6.svg";